import cn from 'classnames';
import styles from './HintIcon.module.scss';

type HintIconProps = {
  className?: string;
  onClick: () => void;
};

export function HintIcon({ className, onClick }: HintIconProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <div className={wrapperClassName} onClick={onClick}>
      <img src="/svg/info.svg" alt="info" className={styles.info} />
    </div>
  );
}
